module.exports = __webpack_public_path__ + "img/indus-pic-5.fa168fbd.png";